<template>
  <v-container class="flex1 text-center justify-center align-content-center" :style="{ 'padding-top': paddingTop }">
    <v-card-text>Não existem dados a serem exibidos.</v-card-text>
  </v-container>
</template>

<script>
export default {
  name: 'EmptyChart',

  props: {
    paddingTop: {
      type: String,
      default: () => '100px',
    },
  },
}
</script>

<style lang="scss" scoped>
.flex1 {
  flex: 1;
  align-self: center;
  text-align: center;
  width: 75%;
  height: 300px;
  color: $cinza-d10;
  margin: 0 auto;
}
</style>
